import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { nationalCopy } from '@/mocks/scale';

export default function NationalCopy() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="全国复制"
            title="云铺 · 云店 · 云社员 · 全国复制"
            subtitle="从县域数字商业的基础单元，到全国范围的规模化复制，构建一张可运营的数字商业网络。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {nationalCopy.map((item, i) => (
            <Reveal key={item.title} delay={i * 80}>
              <div className="h-full p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
                <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className={`${item.icon} text-primary-600 text-2xl`}></i>
                </div>
                <h3 className="mt-4 font-heading font-bold text-base text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}